export const getImageUrl = (baseName, ext, subfolder = '') => {
  const subfolderPath = `/${subfolder}`;

  return new URL(`../assets/images${subfolderPath}/settings-${baseName}@2x.${ext}`, import.meta.url).href
}

export const randomNumber = (min = 1, max = 100) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
